import React from "react";
import Modal from "./Modal"; // Import your Modal component
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { post } from "../network/api";
import { useTranslation } from "react-i18next";


const AddAddressModal = ({ isOpen, onClose, onAddAddress }) => {
  const { t } = useTranslation();
  // Validation schema using Yup
  const validationSchema = Yup.object({
    address: Yup.string()
      .trim()
      .min(5, "Address must be at least 5 characters")
      .max(100, "Address can't be longer than 100 characters")
      .required("Address is required"),
    
    entrance: Yup.string()
      .max(50, "Entrance can't be longer than 50 characters")
      .required("Entrance is required"),
    
    floor: Yup.string()
      .matches(/^[0-9]*$/, "Floor must be a number")
      .max(3, "Floor number can't exceed 3 digits")
      .required("Floor is required"),
    
    officeApartment: Yup.string()
      .max(20, "Office/apartment number can't be longer than 20 characters")
      .required("Office/Apartment number is required"),
    
    instructions: Yup.string()
      .max(200, "Instructions can't be longer than 200 characters")
  });
  

  const handleSubmit = (values) => {
    
    // onAddAddress(values); // Add the new address details to the list
    // onClose(); // Close the modal
    addAddress(values)
  };

  const addAddress = async (values) => {
        const response = await post(
          `customer/search-place`,
          {
            'query':values.address
          }
        )      
        console.log(response[0])
        const addressResponse = await post(
          'customer/address/add-address',
          {
            'place_id':response[0].place_id,
            'address':values.address,
            'entrance':values.entrance,
            'floor':values.floor,
            'office_apartment_no':values.officeApartment,
            'instructions':values.instructions,
            'city': "-",
            'lat':response[0].geometry.location.lat,
            'long':response[0].geometry.location.lng,
            'formatted_address':response[0].formatted_address
          }
        );

        console.log(addressResponse)
        onAddAddress(addressResponse); 
    onClose(); // Close the modal
  }

  return (
    <Modal show={isOpen} onClose={onClose} size="md">
      <h3 className="card_title">{t("add_new_address")}</h3>
      <Formik
        initialValues={{
          address: "",
          entrance: "",
          floor: "",
          officeApartment: "",
          instructions: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ touched, errors }) => (
          <Form>
            <div className="address_form">
              {/* Address Field */}
              <div className="form_group">
                <label htmlFor="address">{t("address")}</label>
                <Field
                  type="text"
                  name="address"
                  placeholder={t("enter_address_here")}
                  className={`input-address ${
                    touched.address && errors.address ? "error" : ""
                  }`}
                />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="error"
                />
              </div>

              {/* Entrance Field */}
              <div className="form_group">
                <label htmlFor="entrance">{t("entrance")}</label>
                <Field
                  type="text"
                  name="entrance"
                  placeholder={t("enter_entrance_here")}
                  className={`input-address ${
                    touched.entrance && errors.entrance ? "error" : ""
                  }`}
                />
                <ErrorMessage
                  name="entrance"
                  component="div"
                  className="error"
                />
              </div>

              {/* Floor Field */}
              <div className="form_group">
                <label htmlFor="floor">Floor</label>
                <Field
                  type="text"
                  name={t("floor")}
                  placeholder={t("enter_floor_here")}
                  className={`input-address ${
                    touched.floor && errors.floor ? "error" : ""
                  }`}
                />
                <ErrorMessage name="floor" component="div" className="error" />
              </div>

              {/* Office/Apartment Field */}
              <div className="form_group">
                <label htmlFor="officeApartment">{t("apartment_office")}</label>
                <Field
                  type="text"
                  name="officeApartment"
                  placeholder={t("enter_apartment_office_here")}
                  className={`input-address ${
                    touched.officeApartment && errors.officeApartment
                      ? "error"
                      : ""
                  }`}
                />
                <ErrorMessage
                  name="officeApartment"
                  component="div"
                  className="error"
                />
              </div>

              {/* Instructions for Courier Field */}
              <div className="form_group">
                <label htmlFor="instructions">{t("instuctions_for_courier")}</label>
                <Field
                  as="textarea"
                  name="instructions"
                  placeholder={t("enter_instructions_here")}
                  className={`input-address ${
                    touched.instructions && errors.instructions ? "error" : ""
                  }`}
                />
                <ErrorMessage
                  name="instructions"
                  component="div"
                  className="error"
                />
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  {t("save_address")}
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="btn btn-secondary"
                >
                  {t("cancel")}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddAddressModal;
